import { render, staticRenderFns } from "./GameIcon.vue?vue&type=template&id=ea4cbff6"
import script from "./GameIcon.vue?vue&type=script&lang=js"
export * from "./GameIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports